<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
  data () {
    return {}
  },
  async mounted () {
    // 处理 openid
    if (this.getQueryString('openid')) {
      localStorage.setItem('openid', this.getQueryString('openid'))
    }

    // 处理注册来源
    if (this.getQueryString('registration_source')) {
      localStorage.setItem('registration_source', this.getQueryString('registration_source'))
    }

    // 检查登录状态
    const token = localStorage.getItem('token')
    if (!token || token === 'null' || token === 'undefined') {
      if (this.$route.path !== '/') {
        const isPublicPage = ['/register', '/policy'].includes(this.$route.path)
        const hasOpenid = localStorage.getItem('openid')

        if (!(isPublicPage && hasOpenid)) {
          this.$router.replace({
            path: '/?link=' + (this.$route.query.link || '')
          })
        }
      }
    }
  },
  methods: {
    getQueryString (name) {
      const regex = new RegExp('[?|&]' + name + '=([^&;]+?)(&|#|;|$)')
      const result = regex.exec(location.href) || ['', '']
      return decodeURIComponent(result[1].replace(/\+/g, '%20')) || null
    }
  }
}
</script>

<style>
/* 全局基础样式 */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  -webkit-tap-highlight-color: transparent;
}

html,
body,
#app {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC',
               'Hiragino Sans GB', 'Microsoft YaHei', 'Helvetica Neue',
               Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #1a2a3a;
  background-color: #f5f9fc;
  height: 100%;
  min-height: 100vh;
}

/* 滚动条美化 */
::-webkit-scrollbar {
  width: 4px;
  height: 4px;
}

::-webkit-scrollbar-track {
  background: transparent;
}

::-webkit-scrollbar-thumb {
  background: rgba(0, 183, 238, 0.3);
  border-radius: 2px;
}

/* 禁止选中文本 */
.no-select {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

/* 安全区域适配 */
@supports (padding-bottom: env(safe-area-inset-bottom)) {
  .safe-area-bottom {
    padding-bottom: env(safe-area-inset-bottom);
  }
}

/* Vant 组件样式覆盖 */
.van-toast {
  border-radius: 12px !important;
  padding: 14px 20px !important;
  font-size: 14px !important;
}

.van-dialog {
  border-radius: 16px !important;
}

.van-dialog__header {
  font-weight: 600 !important;
  font-size: 17px !important;
  padding-top: 24px !important;
}

.van-dialog__message {
  font-size: 15px !important;
  line-height: 1.6 !important;
  padding: 20px 24px !important;
}

.van-dialog__confirm {
  font-weight: 600 !important;
}

.van-button--round {
  border-radius: 25px !important;
}

.van-field__control {
  font-size: 15px !important;
}

.van-cell {
  padding: 14px 16px !important;
}

.van-picker__toolbar {
  height: 50px !important;
}

.van-picker__confirm {
  color: #00b7ee !important;
  font-weight: 600 !important;
}

.van-popup--bottom {
  border-radius: 16px 16px 0 0 !important;
}

/* 复选框和单选框样式 */
.van-checkbox__label,
.van-radio__label {
  font-size: 14px !important;
  color: #1a2a3a !important;
}

/* Tab 样式 */
.van-tabs__line {
  background: linear-gradient(135deg, #00b7ee 0%, #0095c4 100%) !important;
  height: 3px !important;
  border-radius: 2px !important;
}

.van-tab--active {
  font-weight: 600 !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue